/**
 * @class PriceString
 */
export default class PriceString {
    /**
     * @param {String} id
     * @param {String} value
     * @param {String} caption
     * @param {Boolean} visible
     */
    constructor(id, value, caption, visible = true) {
        this._id = id;
        this._value = value;
        this._caption = caption;
        this._visible = visible;

        if (typeof this._id !== "string") {
            throw new Error("Invalid datatype of ID - PriceString");
        }
    }

    /**
     * @return {String}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {String} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get value() {
        return this._value;
    }

    /**
     * @param {String} value
     */
    set value(value) {
        this._value = value;
    }

    /**
     * @return {String}
     */
    get caption() {
        return this._caption;
    }

    /**
     * @param {String} caption
     */
    set caption(caption) {
        this._caption = caption;
    }

    /**
     * @return {Boolean}
     */
    get visible() {
        return this._visible;
    }

    /**
     * @param {Boolean} visible
     */
    set visible(visible) {
        this._visible = visible;
    }

    /**
     * @return {String}
     */
    toString() {
        return "PriceString (" + this._id + ")";
    }
}
